import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get, flattenDeep, reverse, groupBy, orderBy, debounce, map } from 'lodash';
import { Dialog, IconButton, RaisedButton } from 'material-ui';
import Modal from 'react-modal';

import { shouldUse } from 'utils/valuesByKey';
import { fetchCoursesIfNeeded, attendCourse, leaveCourse } from 'actions/courses';
import PanelMessage from 'components/panels/PanelMessage';
import Alert from 'components/Alert';
import DetailList from 'components/DetailList';
import Loading from 'components/Loading';
import KCourse from 'components/KJRN/KCourse';
import KTitle from 'components/KJRN/KTitle';
import Questionnaire from './Questionnaire';

const styles = {
  container: {
    paddingTop: 16,
    paddingBottom: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 1344,
    margin: 'auto',
  },
  titleContainer: {
    width: '100%',
  },
  title: {
    fontSize: 32,
    marginTop: 12,
    marginBottom: 12,
  },
};

const optFields = ['CourseCost', 'CourseDeadlineStart', 'CourseDeadlineEnd'];

const attendIsOk = ({ entity: { CourseDeadlineStart }, CourseAttendingAvailable, CourseBegda }) => {
  if (!CourseAttendingAvailable.value) return false;
  const start = new Date(CourseBegda.entityValue);
  const buffer = CourseDeadlineStart || 0;
  start.setHours(start.getHours() - buffer);
  if (Date.now() < start.getTime()) return true;
  return false;
};

const leaveIsOk = ({ entity: { CourseDeadlineEnd }, CourseStatusPlannedName, CourseBegda }) => {
  if (CourseStatusPlannedName.value !== 'Virkt') return false;
  const start = new Date(CourseBegda.entityValue);
  const buffer = CourseDeadlineEnd || 0;
  start.setHours(start.getHours() - buffer);
  if (Date.now() < start.getTime()) return true;
  return false;
};

class Courses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      dialogOpen: false,
      dialogContent: [],
      questionnaireDialogOpen: false,
      questionnaireRootID: null,
      questionnaireCourseId: 0,
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(fetchCoursesIfNeeded());
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyPress);
    this.checkRoute(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkRoute(nextProps);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyPress);
  }

  onKeyPress = (event) => {
    if (event.keyCode === 27 && this.state.dialogOpen) {
      this.closeDialog();
    }
  }

  getContent(current) {
    const { valuesByKey } = this.props;
    return current.detailFields
      .filter(f => (!optFields.includes(f) ? true : get(valuesByKey, [`Show.Course.${f}`, 'Value']) === 'true'))
      .map(f => current[f]);
  }

  checkRoute = (props) => {
    const courseId = props.router.params.courseId;
    if (props.loaded && courseId) {
      let current = props.openCourses.find(o => o.CourseID.value.toString() === courseId);
      if (current !== undefined) {
        const dialogContent = this.getContent(current);
        const dialogAction = (
          <RaisedButton
            label={<FormattedMessage id="courses.attend" />}
            primary
            disabled={!attendIsOk(current)}
            onClick={() => this.attendCheck(current.CourseID.value, current.entity.QAElementID)}
          />
        );
        this.setState({ dialogContent, dialogOpen: true, dialogAction });
      } else {
        current = props.attendingCourses.find(a => a.CourseID.value.toString() === courseId);
        if (current === undefined) return;
        const dialogContent = this.getContent(current);
        const dialogAction = (
          <RaisedButton
            data-cy="button-leave"
            label={<FormattedMessage id="courses.leave" />}
            secondary
            disabled={!leaveIsOk(current)}
            onClick={() => this.setState({ courseId: current.CourseID.value, courseAttendeeId: current.CourseAttendeeID.value, alertOpen: true })}
          />
        );
        this.setState({ dialogContent, dialogOpen: true, dialogAction });
      }
    }
  }

  mapAttendAction = (c) => {
    const dialogContent = this.getContent(c);
    const dialogAction = (
      <RaisedButton
        label={<FormattedMessage id="courses.attend" />}
        primary
        disabled={!attendIsOk(c)}
        onClick={() => this.attendCheck(c.CourseID.value, c.entity.QAElementID)}
      />
    );
    return {
      ...c,
      actions: [{
        label: <FormattedMessage id="courses.attend" />,
        primary: true,
        disabled: !attendIsOk(c),
        action: () => this.attendCheck(c.CourseID.value, c.entity.QAElementID),
      }, {
        label: <FormattedMessage id="courses.details" />,
        action: () => { this.setState({ dialogContent, dialogOpen: true, dialogAction }); },
      }],
    };
  }

  mapLeaveAction = (c) => {
    const dialogContent = this.getContent(c);
    const dialogAction = (
      <RaisedButton
        data-cy="button-leave"
        label={<FormattedMessage id="courses.leave" />}
        secondary
        disabled={!leaveIsOk(c)}
        onClick={() => this.setState({ courseId: c.CourseID.value, courseAttendeeId: c.CourseAttendeeID.value, alertOpen: true })}
      />
    );
    return {
      ...c,
      actions: [{
        label: <FormattedMessage id="courses.leave" />,
        secondary: true,
        disabled: !leaveIsOk(c),
        action: () => this.setState({ courseId: c.CourseID.value, courseAttendeeId: c.CourseAttendeeID.value, alertOpen: true }), // this.props.dispatch(leaveCourse(c.CourseAttendeeID.value)),
      }, {
        label: <FormattedMessage id="courses.details" />,
        action: () => this.setState({ dialogContent, dialogOpen: true, dialogAction }),
      }],
    };
  }

  closeDialog = () => {
    this.setState({ dialogOpen: false, dialogContent: [], dialogAction: null }, () => {
      if (this.props.location.query.dashboard) this.context.router.push({ pathname: '/' });
      if (this.context.router.params.courseId) this.context.router.push({ pathname: '/events' });
    });
  }
  closeAlert = () => this.setState({ alertOpen: false });
  closeQuestionnaire = () => this.setState({ questionnaireDialogOpen: false, questionnaireRootID: null, questionnaireCourseId: 0 });
  leave = () => { this.props.dispatch(leaveCourse(this.state.courseAttendeeId, this.state.courseId)); this.closeAlert(); this.closeDialog(); };
  attend = (courseId, answerRootId) => {
    this.props.dispatch(attendCourse(courseId, answerRootId));
    this.closeQuestionnaire();
    this.closeDialog();
  }
  attendCheck = debounce((courseId, questionnaireRootID) => {
    if (questionnaireRootID) {
      this.setState({
        dialogOpen: false,
        questionnaireDialogOpen: true,
        questionnaireRootID,
        questionnaireCourseId: courseId,
      });
    } else {
      this.attend(courseId);
    }
  }, 1200, {
    leading: true,
    trailing: false,
  });

  render() {
    const {
      openCourses,
      attendingCourses,
      showErrorMessage,
      coursesError,
      loaded,
      valuesByKey,
      Gender,
      EmployeeMasterID,
    } = this.props;
    const {
      alertOpen,
      dialogOpen,
      dialogContent,
      dialogAction,
      questionnaireDialogOpen,
      questionnaireRootID,
      questionnaireCourseId,
    } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    if (showErrorMessage) {
      return <PanelMessage message={coursesError} iconName="error" type="error" />;
    }

    const useGroup = shouldUse(valuesByKey, 'CourseGroup');
    const useEvents = shouldUse(valuesByKey, 'Events');
    const useCourseOrderReverse = shouldUse(valuesByKey, 'CourseOrderReverse');

    const attendingCoursesWithActions = map(attendingCourses, this.mapLeaveAction);
    const openCoursesWithAction = map(openCourses, this.mapAttendAction);

    const groupedOpenCourses = useGroup
      ? groupBy(openCoursesWithAction, c => c.CourseGroupName.entityValue)
      : groupBy(openCoursesWithAction, c => c.CourseTypeName.entityValue);

    let attMess = <FormattedMessage id="courses.attending" />;

    if (Gender === '1') {
      attMess = <FormattedMessage id="courses.attending.male" />;
    } else if (Gender === '2') {
      attMess = <FormattedMessage id="courses.attending.female" />;
    }

    const attendingC = (attendingCoursesWithActions && attendingCoursesWithActions.length) ? [
      <KTitle containerStyle={styles.titleContainer} key="wertyuio" title={attMess} />,
      map(orderBy(attendingCoursesWithActions, [c => new Date(c.CourseBegda.entityValue).getTime()], ['asc']), course => (
        <KCourse Gender={Gender} useGroup={useGroup} key={course.CourseID.value} attending EmployeeMasterID={EmployeeMasterID} {...course} />
      )),
    ] : [];

    const openC = map(groupedOpenCourses, (group, key) => (
      [
        <KTitle containerStyle={styles.titleContainer} key={key} title={useGroup ? group[0].CourseGroupName.value : group[0].CourseTypeName.value} />,
        map(orderBy(group, [c => new Date(c.CourseBegda.entityValue).getTime()], ['asc']), course => (
          <KCourse Gender={Gender} useGroup={useGroup} key={course.CourseID.value} EmployeeMasterID={EmployeeMasterID} {...course} />
        )),
      ]
    ));

    const courses = [attendingC, openC];
    const empty = !courses || !flattenDeep(courses).length;

    return (
      <div style={styles.container}>
        <KTitle
          title={useEvents ?
            <FormattedMessage id="events.title" /> :
            <FormattedMessage id="courses.title" />
          }
          style={styles.title}
          containerStyle={styles.titleContainer}
        />
        <Dialog
          contentStyle={{ overflow: 'hidden' }}
          open={dialogOpen}
          onRequestClose={this.closeDialog}
          autoScrollBodyContent
          actions={[dialogAction]}
        >
          <IconButton
            style={{ margin: -24, float: 'right' }}
            iconClassName="material-icons"
            onClick={this.closeDialog}
          >
            close
          </IconButton>
          <DetailList itemMaxWidth={350} dataSource={dialogContent} />
        </Dialog>
        {questionnaireRootID &&
          <Modal
            // overlayStyle={{ padding: 0 }}
            isOpen={questionnaireDialogOpen}
            onRequestClose={this.closeQuestionnaire}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
              },
            }}
          >
            <div style={{ minWidth: '50vw', height: '64vh' }}>
              <Questionnaire
                questionnaireRootID={questionnaireRootID}
                onSuccess={answerRootId => this.attend(questionnaireCourseId, answerRootId)}
              />
            </div>
          </Modal>
        }
        <Alert
          open={alertOpen}
          onOk={this.leave}
          onCancel={this.closeAlert}
          text={<FormattedMessage id="courses.alert" />}
        />
        {empty && <div style={{ marginLeft: 16 }}><PanelMessage type="info" iconName="info" message={<FormattedMessage id="courses.empty" />} /></div>}
        {useCourseOrderReverse ? reverse(courses) : courses}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    valuesByKey: state.WebValuesReducer.valuesByKey,
    loaded: state.coursesReducer.coursesLoaded,
    gender: state.loginReducer.user.GenderType,
    openCourses: state.coursesReducer.openCourses,
    attendingCourses: state.coursesReducer.attendingCourses,
    showErrorMessage: ((state.coursesReducer.coursesError && state.coursesReducer.coursesError.Message.length) > 0),
    coursesError: state.coursesReducer.coursesError && state.coursesReducer.coursesError.Message,
    Gender: state.loginReducer.user && state.loginReducer.user.Gender,
    EmployeeMasterID: get(state, 'loginReducer.user.EmployeeMasterID', 0),
  };
}

Courses.contextTypes = {
  router: PropTypes.object.isRequired,
};

Courses.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  openCourses: PropTypes.array,
  attendingCourses: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  coursesError: PropTypes.string,
  Gender: PropTypes.string.isRequired,
  EmployeeMasterID: PropTypes.number.isRequired,
  valuesByKey: PropTypes.object,
  location: PropTypes.object,
};

export default connect(mapStateToProps)(Courses);



// WEBPACK FOOTER //
// ./src/containers/Courses.js